import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { GlobalHttpClient } from '../global.http.client';
import { ISearchService } from './search.service';
import { Observable } from 'rxjs';
import { CompetitorDto, CurrentCompetitorsSearchModel } from '../models/competitors/competitor.models';
import { IPage } from '../models/common/paging';

@Injectable()
export class CompetitorCurrentService extends BaseService implements ISearchService<CurrentCompetitorsSearchModel, CompetitorDto> {
    constructor(http: GlobalHttpClient) {
        super(http);
    }

    search(request: CurrentCompetitorsSearchModel): Observable<IPage<CompetitorDto>> {
        return this.http.post<IPage<CompetitorDto>>('competitors/getCompetitors', request);
    }

    getAwardsForCompany(companyName: string) {
        return this.http.get(`competitors/getAwardsForCompany/${companyName}`);
    }

    remove(companyName: string) {
        var competitorDto = new CompetitorDto();
        competitorDto.name = companyName;

        var result = this.http.post('competitors/remove', competitorDto);
        return result;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/competitor.current.service.ts